import { render, staticRenderFns } from "./InsLogo.vue?vue&type=template&id=e49de158&scoped=true&"
import script from "./InsLogo.vue?vue&type=script&lang=ts&"
export * from "./InsLogo.vue?vue&type=script&lang=ts&"
import style0 from "./InsLogo.vue?vue&type=style&index=0&id=e49de158&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49de158",
  null
  
)

export default component.exports